module.exports = __webpack_public_path__ + "img/tu02.de1b1e53.jpg";